module.exports = __webpack_public_path__ + "img/wi-fi.21cd59b3.svg";